import React from 'react';
import styles from './LoadingSplash.module.css';
/**
 * LoadingSplash — full-screen loading overlay used during:
 *  - initial auth check (App.js)
 *  - app data loading (App.js, `!loaded` gate)
 *  - permissions loading (App.js, `permsLoading` gate)
 *  - login → portal hub transition
 *  - portal click → portal mount transition (later)
 *
 * Props:
 *  - context  (string, optional) — secondary line below the brand mark.
 *               Defaults to 'Operations Hub'. Examples: 'Originals', 'Signing you in', 'Signing you out'.
 *  - label    (string, optional) — small-caps mono label under the dots. Defaults to 'Loading'.
 *  - fadeIn   (boolean, optional) — when true, runs the entrance fade. Default true.
 *               Pass false for splash that's already visible (avoids flicker).
 */
export function LoadingSplash({ context = 'Operations Hub', label = 'Loading', fadeIn = true }) {
  return (
    <div className={`${styles.splashRoot} ${fadeIn ? styles.splashFadeIn : ''}`}>
      <div className={styles.brand}>
        <span className={styles.brandTop}>Carolina Lemke</span>
        <span className={styles.brandBottom}>Berlin</span>
      </div>
      <div className={styles.divider} aria-hidden="true"></div>
      <div className={styles.context}>{context}</div>
      <div className={styles.dots} aria-label="Loading" role="status">
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}
export default LoadingSplash;
